import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
const Places = () => {
  const [img1, setImg1] = useState(true);
  const [img2, setImg2] = useState(false);
  const [img3, setImg3] = useState(false);
  const [img4, setImg4] = useState(false);
  function handleImg1() {
    setImg1(true);
    setImg2(false);
    setImg3(false);
    setImg4(false);
  }
  function handleImg2() {
    setImg2(true);
    setImg1(false);
    setImg3(false);
    setImg4(false);
  }
  function handleImg3() {
    setImg3(true);
    setImg2(false);
    setImg1(false);
    setImg4(false);
  }
  function handleImg4() {
    setImg4(true);
    setImg2(false);
    setImg3(false);
    setImg1(false);
  }

  return (
    <div className="aboutpage2-main">
      <div className="places-main">
        <div className="aboutpage2">
          <img
            className="about2ndpageimg1"
            loading="lazy"
            src="/Assets/57f.webp"
            alt="about2ndpageimg"
          ></img>
          <img
            loading="lazy"
            className="about2ndpageimg1"
            src="/Assets/57f.webp"
            alt="about2ndpageimg"
          ></img>
        </div>
        <div className="aboutpage2-text-container">
          <div className="aboutpage2-text-heading">
            PLACES AT SURYA VILAS PALACE
          </div>
          <img
            className="aboutpage2-img"
            loading="lazy"
            src="/Assets/Group615.webp"
            alt="group615img"
          ></img>
          <p className="aboutpage2-text">
            Lorem ipsum dolor sit amet consectetur. Adipiscing lectus sit sit
            sed semper vitae faucibus consequat. Sed dui auctor aliquam quam
            urna magna feugiat egestas placerat. Pharetra arcu nulla lacus
            molestie quis dignissim quis tempor interdum. Quam blandit iaculis
            ante pellentesque lectus viverra tristique ultrices. Adipiscing
            purus mattis leo sit mi id sed. Eleifend sed enim odio sapien
            tincidunt viverra. Interdum congue eu bibendum tellus odio.
          </p>
        </div>
      </div>

      <div className="about2page2">
        <div className={img1 ? "width-height" : "none width-height"}>
          <img
            className="places1-img width-height relative "
            loading="lazy"
            src="/Assets/places1.webp"
            alt="img"
          ></img>
        </div>
        <div className={img2 ? "width-height" : "none width-height"}>
          <img
            className="places2-img width-height relative"
            loading="lazy"
            src="/Assets/places2.webp"
            alt="img"
          ></img>
        </div>
        <div className={img3 ? "width-height" : "none width-height"}>
          <img
            className="places3-img width-height relative"
            loading="lazy"
            src="/Assets/places3.webp"
            alt="img"
          ></img>
        </div>
        <div className={img4 ? " width-height" : "none width-height"}>
          <img
            className="places4img width-height relative"
            loading="lazy"
            src="/Assets/places4.webp"
            alt="img"
          ></img>
        </div>
        <div className="about2page2-text-container width-height">
          <div className="about2page2-text col-3" onMouseEnter={handleImg1}>
            <p className="aboutpage-text1">Palace</p>
            <p className="aboutpage-text-hidden">
              Historically important,authentically noble and architecturally
              precious-Taj Palaces are spaces of splendour embodying the
              grandeur of kings and queens, whose legacy of luxury lives on.
            </p>
          </div>
          <div className="about2page2-text1 col-3" onMouseEnter={handleImg2}>
            <p className="aboutpage-text1">Restaurant</p>
            <p className="aboutpage-text-hidden">
              Historically important,authentically noble and architecturally
              precious-Taj Palaces are spaces of splendour embodying the
              grandeur of kings and queens, whose legacy of luxury lives on.
            </p>
          </div>
          <div className="about2page2-text2 col-3" onMouseEnter={handleImg3}>
            <p className="aboutpage-text1">Banquet</p>
            <p className="aboutpage-text-hidden">
              Historically important,authentically noble and architecturally
              precious-Taj Palaces are spaces of splendour embodying the
              grandeur of kings and queens, whose legacy of luxury lives on.
            </p>
          </div>
          <div className="about2page2-text3 col-3" onMouseEnter={handleImg4}>
            <p className="aboutpage-text1">Swimming Pool</p>
            <p className="aboutpage-text-hidden">
              Historically important,authentically noble and architecturally
              precious-Taj Palaces are spaces of splendour embodying the
              grandeur of kings and queens, whose legacy of luxury lives on.
            </p>
          </div>
        </div>
      </div>
      <div className="places-swiper">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 1500, disableOnInteraction: false }}
          loop
          slidesPerView={1}
        >
          <SwiperSlide>
            <div className="swiper-space">
              <div className="swiper-text-container1">
                <p className="aboutpage-text1">Palace</p>
                <p className="aboutpage-text-hidden">
                  Historically important,authentically noble and architecturally
                  precious-Taj Palaces are spaces of splendour embodying the
                  grandeur of kings and queens, whose legacy of luxury lives on.
                </p>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="swiper-space">
              <div className="swiper-text-container2">
                <p className="aboutpage-text1">Restaurant</p>
                <p className="aboutpage-text-hidden">
                  Historically important,authentically noble and architecturally
                  precious-Taj Palaces are spaces of splendour embodying the
                  grandeur of kings and queens, whose legacy of luxury lives on.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper-space">
              <div className="swiper-text-container3">
                <p className="aboutpage-text1">Banquet</p>
                <p className="aboutpage-text-hidden">
                  Historically important,authentically noble and architecturally
                  precious-Taj Palaces are spaces of splendour embodying the
                  grandeur of kings and queens, whose legacy of luxury lives on.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="swiper-space">
              <div className="swiper-text-container4">
                <p className="aboutpage-text1">Swimming Pool</p>
                <p className="aboutpage-text-hidden">
                  Historically important,authentically noble and architecturally
                  precious-Taj Palaces are spaces of splendour embodying the
                  grandeur of kings and queens, whose legacy of luxury lives on.
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default Places;
